<button
  class="p-2 hover:bg-[#F9FAFB] relative cursor-pointer"
  (click)="toggleNotifications($event)"
>
  <img [src]="notificationsOpen() ? 'assets/icons/notification-open-3-line.svg' : 'assets/icons/notification-3-line.svg'"  alt="icon" />

  @if (unreadCount() > 0) {
    <span
      class="absolute -top-0.5 -right-0.5
            min-w-[18px] h-[18px] px-1
            rounded-full bg-[var(--feedback-bg-error)] text-[var(--feedback-text-on-error-solid)]
            qbrain-text-xs leading-[18px] font-bold
            flex items-center justify-center"
    >
      {{ unreadCount() }}
    </span>
  }
</button>

<notification-modal
  [(visible)]="notificationsOpen"
  (closed)="onNotificationsClosed()"
>
</notification-modal>
